import ApiService from '../api.service';

const API_ENDPOINT = 'users';

export const UserService = {
  /**
   * Get users by store
   * @param {string} storeId - Store ID
   * @returns {Promise} - API response
   */
  getUsersByStore(storeId) {
    return ApiService.query(`${API_ENDPOINT}/get-by-store`, {
      params: { storeId },
    });
  },

  /**
   * Get users by list of stores
   * @param {Array} storeIds - Array of store IDs
   * @returns {Promise} - API response
   */
  getUsersByListStore(storeIds) {
    return ApiService.query(`${API_ENDPOINT}/get-by-list-store`, {
      params: { storeIds },
    });
  },

  /**
   * Create a new user
   * @param {Object} userData - User data
   * @returns {Promise} - API response
   */
  createUser(userData) {
    return ApiService.post(API_ENDPOINT, userData);
  },

  /**
   * Update an existing user
   * @param {Object} userData - Updated user data
   * @returns {Promise} - API response
   */
  updateUser(userData) {
    return ApiService.put(API_ENDPOINT, userData);
  },

  /**
   * Get current user profile
   * @returns {Promise} - API response
   */
  getProfile() {
    return ApiService.get(`${API_ENDPOINT}/profile`);
  },

  /**
   * Find user by username
   * @param {string} userName - Username to search
   * @returns {Promise} - API response
   */
  findByUsername(userName) {
    return ApiService.query(API_ENDPOINT, { params: { userName } });
  },

  /**
   * List users with pagination
   * @param {Object} params - Query parameters
   * @param {string|undefined} params.userName - Username to search
   * @param {string|undefined} params.fullName - Fullname to search
   * @param {string|undefined} params.roleId - RoleId to search
   * @returns {Promise} - API response
   */
  listUsers(params) {
    return ApiService.query(`${API_ENDPOINT}/list`, { params });
  },

  /**
   * Generate password hash
   * @param {string} password - Password to hash
   * @returns {Promise} - API response
   */
  generatePassword(password) {
    return ApiService.get(`${API_ENDPOINT}/password/generate`, {
      params: { password },
    });
  },

  /**
   * Check if username is already taken
   * @param {string} userName - Username to check
   * @returns {Promise} - API response
   */
  checkUsername(userName) {
    return ApiService.get(`${API_ENDPOINT}/check`, { params: { userName } });
  },

  /**
   * Find user by ID
   * @param {string} id - User ID
   * @returns {Promise} - API response
   */
  findById(id) {
    return ApiService.get(`${API_ENDPOINT}/${id}`);
  },

  /**
   * Activate a user account
   * @param {string} id - User ID
   * @returns {Promise} - API response
   */
  activateUser(id) {
    return ApiService.post(`${API_ENDPOINT}/active/${id}`);
  },

  /**
   * Restore user password
   * @param {string} id - User ID
   * @returns {Promise} - API response
   */
  restorePassword(id) {
    return ApiService.post(`${API_ENDPOINT}/password/restore/${id}`);
  },

  /**
   * Smart search for users
   * @param {Object} params - Search parameters
   * @param {string|undefined} params.keyword - Keyword to search
   * @param {string|undefined} params.storeId - StoreId to search
   * @returns {Promise} - API response
   */
  smartSearch(params) {
    return ApiService.query(`${API_ENDPOINT}/smart-search`, { params });
  },
};
